import * as Yup from "yup";

export const tutorSchema = Yup.object().shape({
  uid: Yup.number(),
  companyUID: Yup.number(),
  departmentUID: Yup.number(),
  name: Yup.string().required("강사명을 입력하세요"), // 강사명
  carreer: Yup.string().required("경력사항을 입력하세요"), // 경력사항
  qualification: Yup.string().required("자격현황을 입력하세요"), // 자격현황
  internalEducation: Yup.string(), // 내부교육이수현황
  externalEducation1: Yup.string(), // 외부교육이수현황1
  externalEducation2: Yup.string(), // 외부교육이수현황1
  certificationFile: Yup.string(), // 수료증 파일
  note: Yup.string(), // 비고
  isDeleted: Yup.boolean(), // 삭제여부
});

